module.exports = {"469023100":"金江镇","469023101":"老城镇","469023102":"瑞溪镇","469023103":"永发镇","469023104":"加乐镇","469023105":"文儒镇","469023106":"中兴镇","469023107":"仁兴镇","469023108":"福山镇","469023109":"桥头镇","469023110":"大丰镇","469023405":"国营金安农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/469023.json
// module id = 2333
// module chunks = 0